var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharmCircleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.937 85.3127C134.062 109.688 115.683 132.639 89.8941 137.768C77.3166 140.272 64.2693 138.745 52.6102 133.403C40.951 128.062 31.2744 119.178 24.9581 108.016C18.6418 96.8551 16.0078 83.9856 17.4313 71.2403C18.8547 58.4949 24.2629 46.5235 32.8859 37.0307C50.5724 17.5502 80.4366 12.1877 104.812 21.9377",
    stroke: "#04394F",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0625 75.5625L80.4375 99.9375L138.938 36.5625",
    stroke: "#04394F",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharmCircleTick);
export default __webpack_public_path__ + "static/media/charm_circle-tick.7208182598fb92bf445f1ddb3e05e62f.svg";
export { ForwardRef as ReactComponent };